import { EditModel } from '../../../../api-gen/gen/models/edit-model';
import { Model } from '../../../../api-gen/gen/models/model';
import { VideoModel } from '../../../../api-gen/gen/models/video-model';
import { VideoExtensionModel } from '../../../../api-gen/gen/models/video-extension-model';

export interface AiModelOption {
  value: Model | VideoModel | EditModel | VideoExtensionModel;
  name: string;
  description: string;
  icon: string;
  isNew?: boolean;
  uncensored?: boolean;
}

export const AI_MODEL_OPTIONS: AiModelOption[] = [
  {
    value: Model.Default,
    name: 'Creative v2',
    description:
      'Versatile model with strong prompt understanding for realistic or creative characters and scenes.',
    icon: 'auto_awesome',
    uncensored: true,
  },
  {
    value: Model.Realism,
    name: 'Realism (Beta)',
    description:
      'Advanced model that produces highly photorealistic images with perfect skin and body details.',
    icon: 'photo_camera',
    uncensored: true,
  },
  {
    value: Model.Krea,
    name: 'Krea2 Uncensored',
    description:
      'Uncensored model for realistic and creative images. Perfect for adult content and NSFW prompts.',
    icon: '18_up_rating',
    uncensored: true,
    isNew: true,
  },
  {
    value: Model.Temporary,
    name: 'Limited: Dreamy Realism V2',
    description:
      'Limited-time experimental model — try it out and explore the latest AI styles.',
    icon: 'blur_on',
    uncensored: true,
  },
  {
    value: Model.CharacterCreator,
    name: 'Character Creator',
    description:
      'Build characters step by step by mixing attributes, outfits, scenes and styles.',
    icon: 'tune',
    uncensored: true,
  },
  {
    value: Model.Anima,
    name: 'Anima 1.0',
    description:
      'Versatile artistic model focused on anime and manga with strong creative capabilities.',
    icon: 'palette',
    isNew: false,
    uncensored: true,
  },
  {
    value: Model.Zimage,
    name: 'Social Media',
    description:
      'High-quality realistic images in authentic influencer style, like real Instagram photos.',
    icon: 'star',
    isNew: true,
    uncensored: true,
  },
  {
    value: Model.Grok,
    name: 'Grok Ultra',
    description:
      'Advanced model for realistic images with great prompt understanding. Perfect for social media / influencer content.',
    icon: 'psychology',
    isNew: false,
  },
  {
    value: Model.Seeddance,
    name: 'SeedDance 4.5',
    description:
      'High-quality image generation with strong prompt understanding.',
    icon: 'motion_photos_on',
    isNew: false,
    uncensored: true,
  },
  {
    value: Model.Anime,
    name: 'Anime & Cartoon',
    description:
      'Stylized model for anime, hentai, manga and cartoon-inspired characters and scenes.',
    icon: 'brush',
    uncensored: true,
  },
];

export const EDIT_MODEL_OPTIONS: AiModelOption[] = [
  {
    value: EditModel.Realism,
    name: 'Realism',
    description:
      'Photorealistic edits — best for natural-looking changes to faces, bodies and scenes.',
    icon: 'photo_camera',
    uncensored: true,
  },
  {
    value: EditModel.QwenPro,
    name: 'Pro Edit',
    description:
      'Higher-quality model with strong prompt understanding for detailed, precise edits.',
    icon: 'auto_fix_high',
    uncensored: true,
  },
  {
    value: EditModel.Creative,
    name: 'Creative 2.0',
    description:
      'Versatile creative model — flexible edits, stylization and broader scene changes.',
    icon: 'auto_awesome',
    uncensored: true,
  },
  {
    value: EditModel.Krea,
    name: 'Krea Experimental',
    description:
      'Experimental AI Model. Works best for placing existing characters in new environments.',
    icon: 'science',
    isNew: true,
    uncensored: true,
  },
  {
    value: EditModel.Grok,
    name: 'Grok Ultra',
    description:
      'Advanced model for realistic images with great prompt understanding. Best for complex edits and high-quality results.',
    icon: 'psychology',
  },
  {
    value: EditModel.Seeddance,
    name: 'SeedDance 4.5',
    description: 'High-quality image editing with strong prompt understanding.',
    icon: 'motion_photos_on',
    uncensored: true,
  },
];
